import { AvailableSharedRoutes } from "../../utils/constants";

export class AuthUtil {
  static getRedirectUrl = (): string => {
    return AvailableSharedRoutes.Portal;
  };
}
